import { SxProps, Theme } from '@mui/material/styles';

export const errorPageWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  width: '100%',
  bgcolor: 'background.default',
};

export const errorPagePaperSx: SxProps<Theme> = {
  p: 4,
  maxWidth: 500,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  borderRadius: 3,
};

export const errorPageIconSx: SxProps<Theme> = {
  fontSize: 64,
  color: 'error.main',
  mx: 'auto',
};

export const errorPageButtonSx: SxProps<Theme> = {
  mt: 2,
  alignSelf: 'center',
};
